export default __webpack_public_path__ + "static/media/person_1.7836c676.png";